/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EdgeConfiguration } from '../models';
// @ts-ignore
import type { EdgeConfigurationUpdate } from '../models';
// @ts-ignore
import type { ListEdgeConfigurationsResponse } from '../models';
// @ts-ignore
import type { Status } from '../models';
/**
 * EdgeConfigurationsAPIApi - axios parameter creator
 * @export
 */
export const EdgeConfigurationsAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Method to create edge configuration.
         * @summary Create edge configuration
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the Cluster.
         * @param {string} edgeLocationId The ID of the edge location.
         * @param {EdgeConfiguration} edgeConfiguration 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgeConfigurationsAPICreateEdgeConfiguration: async (organizationId: string, clusterId: string, edgeLocationId: string, edgeConfiguration: EdgeConfiguration, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('edgeConfigurationsAPICreateEdgeConfiguration', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('edgeConfigurationsAPICreateEdgeConfiguration', 'clusterId', clusterId)
            // verify required parameter 'edgeLocationId' is not null or undefined
            assertParamExists('edgeConfigurationsAPICreateEdgeConfiguration', 'edgeLocationId', edgeLocationId)
            // verify required parameter 'edgeConfiguration' is not null or undefined
            assertParamExists('edgeConfigurationsAPICreateEdgeConfiguration', 'edgeConfiguration', edgeConfiguration)
            const localVarPath = `/omni-provisioner/v1beta/organizations/{organizationId}/clusters/{clusterId}/edge-locations/{edgeLocationId}/configurations`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"edgeLocationId"}}`, encodeURIComponent(String(edgeLocationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(edgeConfiguration, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Method to delete edge configuration.
         * @summary Delete edge configuration
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the Cluster.
         * @param {string} edgeLocationId The ID of the edge location.
         * @param {string} id The ID of the edge configuration.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgeConfigurationsAPIDeleteEdgeConfiguration: async (organizationId: string, clusterId: string, edgeLocationId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('edgeConfigurationsAPIDeleteEdgeConfiguration', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('edgeConfigurationsAPIDeleteEdgeConfiguration', 'clusterId', clusterId)
            // verify required parameter 'edgeLocationId' is not null or undefined
            assertParamExists('edgeConfigurationsAPIDeleteEdgeConfiguration', 'edgeLocationId', edgeLocationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('edgeConfigurationsAPIDeleteEdgeConfiguration', 'id', id)
            const localVarPath = `/omni-provisioner/v1beta/organizations/{organizationId}/clusters/{clusterId}/edge-locations/{edgeLocationId}/configurations/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"edgeLocationId"}}`, encodeURIComponent(String(edgeLocationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Method to get edge configuration details.
         * @summary Get edge configuration details
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the Cluster.
         * @param {string} edgeLocationId The ID of the edge location.
         * @param {string} id The ID of the edge configuration.
         * @param {number} [version] The version of the edge configuration to be provided.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgeConfigurationsAPIGetEdgeConfiguration: async (organizationId: string, clusterId: string, edgeLocationId: string, id: string, version?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('edgeConfigurationsAPIGetEdgeConfiguration', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('edgeConfigurationsAPIGetEdgeConfiguration', 'clusterId', clusterId)
            // verify required parameter 'edgeLocationId' is not null or undefined
            assertParamExists('edgeConfigurationsAPIGetEdgeConfiguration', 'edgeLocationId', edgeLocationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('edgeConfigurationsAPIGetEdgeConfiguration', 'id', id)
            const localVarPath = `/omni-provisioner/v1beta/organizations/{organizationId}/clusters/{clusterId}/edge-locations/{edgeLocationId}/configurations/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"edgeLocationId"}}`, encodeURIComponent(String(edgeLocationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Method to list edge configurations.
         * @summary List edge configurations
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the Cluster.
         * @param {string} [edgeLocationId] The ID of the Edge Location configuration belongs to.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgeConfigurationsAPIListEdgeConfigurations: async (organizationId: string, clusterId: string, edgeLocationId?: string, pageLimit?: string, pageCursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('edgeConfigurationsAPIListEdgeConfigurations', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('edgeConfigurationsAPIListEdgeConfigurations', 'clusterId', clusterId)
            const localVarPath = `/omni-provisioner/v1beta/organizations/{organizationId}/clusters/{clusterId}/edge-configurations`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (edgeLocationId !== undefined) {
                localVarQueryParameter['edgeLocationId'] = edgeLocationId;
            }

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Method to update edge configuration parameters.
         * @summary Update edge configuration
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the Cluster.
         * @param {string} edgeLocationId The ID of the edge location.
         * @param {string} id The ID of the edge configuration.
         * @param {EdgeConfigurationUpdate} edgeConfigurationUpdate 
         * @param {string} [updateMask] The list of fields to be updated.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgeConfigurationsAPIUpdateEdgeConfiguration: async (organizationId: string, clusterId: string, edgeLocationId: string, id: string, edgeConfigurationUpdate: EdgeConfigurationUpdate, updateMask?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('edgeConfigurationsAPIUpdateEdgeConfiguration', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('edgeConfigurationsAPIUpdateEdgeConfiguration', 'clusterId', clusterId)
            // verify required parameter 'edgeLocationId' is not null or undefined
            assertParamExists('edgeConfigurationsAPIUpdateEdgeConfiguration', 'edgeLocationId', edgeLocationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('edgeConfigurationsAPIUpdateEdgeConfiguration', 'id', id)
            // verify required parameter 'edgeConfigurationUpdate' is not null or undefined
            assertParamExists('edgeConfigurationsAPIUpdateEdgeConfiguration', 'edgeConfigurationUpdate', edgeConfigurationUpdate)
            const localVarPath = `/omni-provisioner/v1beta/organizations/{organizationId}/clusters/{clusterId}/edge-locations/{edgeLocationId}/configurations/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"edgeLocationId"}}`, encodeURIComponent(String(edgeLocationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (updateMask !== undefined) {
                localVarQueryParameter['updateMask'] = updateMask;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(edgeConfigurationUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EdgeConfigurationsAPIApi - functional programming interface
 * @export
 */
export const EdgeConfigurationsAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EdgeConfigurationsAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Method to create edge configuration.
         * @summary Create edge configuration
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the Cluster.
         * @param {string} edgeLocationId The ID of the edge location.
         * @param {EdgeConfiguration} edgeConfiguration 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async edgeConfigurationsAPICreateEdgeConfiguration(organizationId: string, clusterId: string, edgeLocationId: string, edgeConfiguration: EdgeConfiguration, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EdgeConfiguration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.edgeConfigurationsAPICreateEdgeConfiguration(organizationId, clusterId, edgeLocationId, edgeConfiguration, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EdgeConfigurationsAPIApi.edgeConfigurationsAPICreateEdgeConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Method to delete edge configuration.
         * @summary Delete edge configuration
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the Cluster.
         * @param {string} edgeLocationId The ID of the edge location.
         * @param {string} id The ID of the edge configuration.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async edgeConfigurationsAPIDeleteEdgeConfiguration(organizationId: string, clusterId: string, edgeLocationId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.edgeConfigurationsAPIDeleteEdgeConfiguration(organizationId, clusterId, edgeLocationId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EdgeConfigurationsAPIApi.edgeConfigurationsAPIDeleteEdgeConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Method to get edge configuration details.
         * @summary Get edge configuration details
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the Cluster.
         * @param {string} edgeLocationId The ID of the edge location.
         * @param {string} id The ID of the edge configuration.
         * @param {number} [version] The version of the edge configuration to be provided.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async edgeConfigurationsAPIGetEdgeConfiguration(organizationId: string, clusterId: string, edgeLocationId: string, id: string, version?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EdgeConfiguration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.edgeConfigurationsAPIGetEdgeConfiguration(organizationId, clusterId, edgeLocationId, id, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EdgeConfigurationsAPIApi.edgeConfigurationsAPIGetEdgeConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Method to list edge configurations.
         * @summary List edge configurations
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the Cluster.
         * @param {string} [edgeLocationId] The ID of the Edge Location configuration belongs to.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async edgeConfigurationsAPIListEdgeConfigurations(organizationId: string, clusterId: string, edgeLocationId?: string, pageLimit?: string, pageCursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListEdgeConfigurationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.edgeConfigurationsAPIListEdgeConfigurations(organizationId, clusterId, edgeLocationId, pageLimit, pageCursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EdgeConfigurationsAPIApi.edgeConfigurationsAPIListEdgeConfigurations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Method to update edge configuration parameters.
         * @summary Update edge configuration
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the Cluster.
         * @param {string} edgeLocationId The ID of the edge location.
         * @param {string} id The ID of the edge configuration.
         * @param {EdgeConfigurationUpdate} edgeConfigurationUpdate 
         * @param {string} [updateMask] The list of fields to be updated.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async edgeConfigurationsAPIUpdateEdgeConfiguration(organizationId: string, clusterId: string, edgeLocationId: string, id: string, edgeConfigurationUpdate: EdgeConfigurationUpdate, updateMask?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EdgeConfiguration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.edgeConfigurationsAPIUpdateEdgeConfiguration(organizationId, clusterId, edgeLocationId, id, edgeConfigurationUpdate, updateMask, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EdgeConfigurationsAPIApi.edgeConfigurationsAPIUpdateEdgeConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EdgeConfigurationsAPIApi - factory interface
 * @export
 */
export const EdgeConfigurationsAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EdgeConfigurationsAPIApiFp(configuration)
    return {
        /**
         * Method to create edge configuration.
         * @summary Create edge configuration
         * @param {EdgeConfigurationsAPIApiEdgeConfigurationsAPICreateEdgeConfigurationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgeConfigurationsAPICreateEdgeConfiguration(requestParameters: EdgeConfigurationsAPIApiEdgeConfigurationsAPICreateEdgeConfigurationRequest, options?: RawAxiosRequestConfig): AxiosPromise<EdgeConfiguration> {
            return localVarFp.edgeConfigurationsAPICreateEdgeConfiguration(requestParameters.organizationId, requestParameters.clusterId, requestParameters.edgeLocationId, requestParameters.edgeConfiguration, options).then((request) => request(axios, basePath));
        },
        /**
         * Method to delete edge configuration.
         * @summary Delete edge configuration
         * @param {EdgeConfigurationsAPIApiEdgeConfigurationsAPIDeleteEdgeConfigurationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgeConfigurationsAPIDeleteEdgeConfiguration(requestParameters: EdgeConfigurationsAPIApiEdgeConfigurationsAPIDeleteEdgeConfigurationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.edgeConfigurationsAPIDeleteEdgeConfiguration(requestParameters.organizationId, requestParameters.clusterId, requestParameters.edgeLocationId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Method to get edge configuration details.
         * @summary Get edge configuration details
         * @param {EdgeConfigurationsAPIApiEdgeConfigurationsAPIGetEdgeConfigurationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgeConfigurationsAPIGetEdgeConfiguration(requestParameters: EdgeConfigurationsAPIApiEdgeConfigurationsAPIGetEdgeConfigurationRequest, options?: RawAxiosRequestConfig): AxiosPromise<EdgeConfiguration> {
            return localVarFp.edgeConfigurationsAPIGetEdgeConfiguration(requestParameters.organizationId, requestParameters.clusterId, requestParameters.edgeLocationId, requestParameters.id, requestParameters.version, options).then((request) => request(axios, basePath));
        },
        /**
         * Method to list edge configurations.
         * @summary List edge configurations
         * @param {EdgeConfigurationsAPIApiEdgeConfigurationsAPIListEdgeConfigurationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgeConfigurationsAPIListEdgeConfigurations(requestParameters: EdgeConfigurationsAPIApiEdgeConfigurationsAPIListEdgeConfigurationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListEdgeConfigurationsResponse> {
            return localVarFp.edgeConfigurationsAPIListEdgeConfigurations(requestParameters.organizationId, requestParameters.clusterId, requestParameters.edgeLocationId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Method to update edge configuration parameters.
         * @summary Update edge configuration
         * @param {EdgeConfigurationsAPIApiEdgeConfigurationsAPIUpdateEdgeConfigurationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgeConfigurationsAPIUpdateEdgeConfiguration(requestParameters: EdgeConfigurationsAPIApiEdgeConfigurationsAPIUpdateEdgeConfigurationRequest, options?: RawAxiosRequestConfig): AxiosPromise<EdgeConfiguration> {
            return localVarFp.edgeConfigurationsAPIUpdateEdgeConfiguration(requestParameters.organizationId, requestParameters.clusterId, requestParameters.edgeLocationId, requestParameters.id, requestParameters.edgeConfigurationUpdate, requestParameters.updateMask, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for edgeConfigurationsAPICreateEdgeConfiguration operation in EdgeConfigurationsAPIApi.
 * @export
 * @interface EdgeConfigurationsAPIApiEdgeConfigurationsAPICreateEdgeConfigurationRequest
 */
export interface EdgeConfigurationsAPIApiEdgeConfigurationsAPICreateEdgeConfigurationRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof EdgeConfigurationsAPIApiEdgeConfigurationsAPICreateEdgeConfiguration
     */
    readonly organizationId: string

    /**
     * The ID of the Cluster.
     * @type {string}
     * @memberof EdgeConfigurationsAPIApiEdgeConfigurationsAPICreateEdgeConfiguration
     */
    readonly clusterId: string

    /**
     * The ID of the edge location.
     * @type {string}
     * @memberof EdgeConfigurationsAPIApiEdgeConfigurationsAPICreateEdgeConfiguration
     */
    readonly edgeLocationId: string

    /**
     * 
     * @type {EdgeConfiguration}
     * @memberof EdgeConfigurationsAPIApiEdgeConfigurationsAPICreateEdgeConfiguration
     */
    readonly edgeConfiguration: EdgeConfiguration
}

/**
 * Request parameters for edgeConfigurationsAPIDeleteEdgeConfiguration operation in EdgeConfigurationsAPIApi.
 * @export
 * @interface EdgeConfigurationsAPIApiEdgeConfigurationsAPIDeleteEdgeConfigurationRequest
 */
export interface EdgeConfigurationsAPIApiEdgeConfigurationsAPIDeleteEdgeConfigurationRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof EdgeConfigurationsAPIApiEdgeConfigurationsAPIDeleteEdgeConfiguration
     */
    readonly organizationId: string

    /**
     * The ID of the Cluster.
     * @type {string}
     * @memberof EdgeConfigurationsAPIApiEdgeConfigurationsAPIDeleteEdgeConfiguration
     */
    readonly clusterId: string

    /**
     * The ID of the edge location.
     * @type {string}
     * @memberof EdgeConfigurationsAPIApiEdgeConfigurationsAPIDeleteEdgeConfiguration
     */
    readonly edgeLocationId: string

    /**
     * The ID of the edge configuration.
     * @type {string}
     * @memberof EdgeConfigurationsAPIApiEdgeConfigurationsAPIDeleteEdgeConfiguration
     */
    readonly id: string
}

/**
 * Request parameters for edgeConfigurationsAPIGetEdgeConfiguration operation in EdgeConfigurationsAPIApi.
 * @export
 * @interface EdgeConfigurationsAPIApiEdgeConfigurationsAPIGetEdgeConfigurationRequest
 */
export interface EdgeConfigurationsAPIApiEdgeConfigurationsAPIGetEdgeConfigurationRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof EdgeConfigurationsAPIApiEdgeConfigurationsAPIGetEdgeConfiguration
     */
    readonly organizationId: string

    /**
     * The ID of the Cluster.
     * @type {string}
     * @memberof EdgeConfigurationsAPIApiEdgeConfigurationsAPIGetEdgeConfiguration
     */
    readonly clusterId: string

    /**
     * The ID of the edge location.
     * @type {string}
     * @memberof EdgeConfigurationsAPIApiEdgeConfigurationsAPIGetEdgeConfiguration
     */
    readonly edgeLocationId: string

    /**
     * The ID of the edge configuration.
     * @type {string}
     * @memberof EdgeConfigurationsAPIApiEdgeConfigurationsAPIGetEdgeConfiguration
     */
    readonly id: string

    /**
     * The version of the edge configuration to be provided.
     * @type {number}
     * @memberof EdgeConfigurationsAPIApiEdgeConfigurationsAPIGetEdgeConfiguration
     */
    readonly version?: number
}

/**
 * Request parameters for edgeConfigurationsAPIListEdgeConfigurations operation in EdgeConfigurationsAPIApi.
 * @export
 * @interface EdgeConfigurationsAPIApiEdgeConfigurationsAPIListEdgeConfigurationsRequest
 */
export interface EdgeConfigurationsAPIApiEdgeConfigurationsAPIListEdgeConfigurationsRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof EdgeConfigurationsAPIApiEdgeConfigurationsAPIListEdgeConfigurations
     */
    readonly organizationId: string

    /**
     * The ID of the Cluster.
     * @type {string}
     * @memberof EdgeConfigurationsAPIApiEdgeConfigurationsAPIListEdgeConfigurations
     */
    readonly clusterId: string

    /**
     * The ID of the Edge Location configuration belongs to.
     * @type {string}
     * @memberof EdgeConfigurationsAPIApiEdgeConfigurationsAPIListEdgeConfigurations
     */
    readonly edgeLocationId?: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof EdgeConfigurationsAPIApiEdgeConfigurationsAPIListEdgeConfigurations
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof EdgeConfigurationsAPIApiEdgeConfigurationsAPIListEdgeConfigurations
     */
    readonly pageCursor?: string
}

/**
 * Request parameters for edgeConfigurationsAPIUpdateEdgeConfiguration operation in EdgeConfigurationsAPIApi.
 * @export
 * @interface EdgeConfigurationsAPIApiEdgeConfigurationsAPIUpdateEdgeConfigurationRequest
 */
export interface EdgeConfigurationsAPIApiEdgeConfigurationsAPIUpdateEdgeConfigurationRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof EdgeConfigurationsAPIApiEdgeConfigurationsAPIUpdateEdgeConfiguration
     */
    readonly organizationId: string

    /**
     * The ID of the Cluster.
     * @type {string}
     * @memberof EdgeConfigurationsAPIApiEdgeConfigurationsAPIUpdateEdgeConfiguration
     */
    readonly clusterId: string

    /**
     * The ID of the edge location.
     * @type {string}
     * @memberof EdgeConfigurationsAPIApiEdgeConfigurationsAPIUpdateEdgeConfiguration
     */
    readonly edgeLocationId: string

    /**
     * The ID of the edge configuration.
     * @type {string}
     * @memberof EdgeConfigurationsAPIApiEdgeConfigurationsAPIUpdateEdgeConfiguration
     */
    readonly id: string

    /**
     * 
     * @type {EdgeConfigurationUpdate}
     * @memberof EdgeConfigurationsAPIApiEdgeConfigurationsAPIUpdateEdgeConfiguration
     */
    readonly edgeConfigurationUpdate: EdgeConfigurationUpdate

    /**
     * The list of fields to be updated.
     * @type {string}
     * @memberof EdgeConfigurationsAPIApiEdgeConfigurationsAPIUpdateEdgeConfiguration
     */
    readonly updateMask?: string
}

/**
 * EdgeConfigurationsAPIApi - object-oriented interface
 * @export
 * @class EdgeConfigurationsAPIApi
 * @extends {BaseAPI}
 */
export class EdgeConfigurationsAPIApi extends BaseAPI {
    /**
     * Method to create edge configuration.
     * @summary Create edge configuration
     * @param {EdgeConfigurationsAPIApiEdgeConfigurationsAPICreateEdgeConfigurationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EdgeConfigurationsAPIApi
     */
    public edgeConfigurationsAPICreateEdgeConfiguration(requestParameters: EdgeConfigurationsAPIApiEdgeConfigurationsAPICreateEdgeConfigurationRequest, options?: RawAxiosRequestConfig) {
        return EdgeConfigurationsAPIApiFp(this.configuration).edgeConfigurationsAPICreateEdgeConfiguration(requestParameters.organizationId, requestParameters.clusterId, requestParameters.edgeLocationId, requestParameters.edgeConfiguration, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Method to delete edge configuration.
     * @summary Delete edge configuration
     * @param {EdgeConfigurationsAPIApiEdgeConfigurationsAPIDeleteEdgeConfigurationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EdgeConfigurationsAPIApi
     */
    public edgeConfigurationsAPIDeleteEdgeConfiguration(requestParameters: EdgeConfigurationsAPIApiEdgeConfigurationsAPIDeleteEdgeConfigurationRequest, options?: RawAxiosRequestConfig) {
        return EdgeConfigurationsAPIApiFp(this.configuration).edgeConfigurationsAPIDeleteEdgeConfiguration(requestParameters.organizationId, requestParameters.clusterId, requestParameters.edgeLocationId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Method to get edge configuration details.
     * @summary Get edge configuration details
     * @param {EdgeConfigurationsAPIApiEdgeConfigurationsAPIGetEdgeConfigurationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EdgeConfigurationsAPIApi
     */
    public edgeConfigurationsAPIGetEdgeConfiguration(requestParameters: EdgeConfigurationsAPIApiEdgeConfigurationsAPIGetEdgeConfigurationRequest, options?: RawAxiosRequestConfig) {
        return EdgeConfigurationsAPIApiFp(this.configuration).edgeConfigurationsAPIGetEdgeConfiguration(requestParameters.organizationId, requestParameters.clusterId, requestParameters.edgeLocationId, requestParameters.id, requestParameters.version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Method to list edge configurations.
     * @summary List edge configurations
     * @param {EdgeConfigurationsAPIApiEdgeConfigurationsAPIListEdgeConfigurationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EdgeConfigurationsAPIApi
     */
    public edgeConfigurationsAPIListEdgeConfigurations(requestParameters: EdgeConfigurationsAPIApiEdgeConfigurationsAPIListEdgeConfigurationsRequest, options?: RawAxiosRequestConfig) {
        return EdgeConfigurationsAPIApiFp(this.configuration).edgeConfigurationsAPIListEdgeConfigurations(requestParameters.organizationId, requestParameters.clusterId, requestParameters.edgeLocationId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Method to update edge configuration parameters.
     * @summary Update edge configuration
     * @param {EdgeConfigurationsAPIApiEdgeConfigurationsAPIUpdateEdgeConfigurationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EdgeConfigurationsAPIApi
     */
    public edgeConfigurationsAPIUpdateEdgeConfiguration(requestParameters: EdgeConfigurationsAPIApiEdgeConfigurationsAPIUpdateEdgeConfigurationRequest, options?: RawAxiosRequestConfig) {
        return EdgeConfigurationsAPIApiFp(this.configuration).edgeConfigurationsAPIUpdateEdgeConfiguration(requestParameters.organizationId, requestParameters.clusterId, requestParameters.edgeLocationId, requestParameters.id, requestParameters.edgeConfigurationUpdate, requestParameters.updateMask, options).then((request) => request(this.axios, this.basePath));
    }
}

